(async function () {
    // 确保 DOM 挂载安全的辅助函数
    function ready(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    // ==========================================
    // 0. Cookie 操作辅助函数（优化移动端兼容）
    // ==========================================
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        // 自动识别是否为 HTTPS，加上 Secure 提高移动端 Safari 写入成功率
        const isSecure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax" + isSecure;
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // 根据 ISO 2 位代码获取国家英文全称
    function getCountryName(countryCode) {
        try {
            const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
            return regionNames.of(countryCode) || countryCode;
        } catch (e) {
            return countryCode; // 兼容旧环境降级
        }
    }

    const COOKIE_NAME = 'geo_redirect_dismissed';
    const COOKIE_EXPIRE_DAYS = 7;

    // ==========================================
    // 1. 【SEO 放行】搜索引擎爬虫静默退出
    // ==========================================
    const ua = navigator.userAgent.toLowerCase();
    const isBot = /googlebot|bingbot|yandexbot|slurp|baiduspider|twitterbot|facebookexternalhit|duckduckbot/i.test(ua);
    if (isBot) return;

    // ==========================================
    // 2. Cookie 存在则不再弹窗
    // ==========================================
    if (getCookie(COOKIE_NAME) === 'true') return;

    // ==========================================
    // 3. 配置映射与欧洲市场列表
    // ==========================================
    const geoApiUrl = "https://akapi.angelkiss.cn/geoip/json/";

    const europeCountries = [
      'GB', 'IE', 'FR', 'DE', 'NL', 'BE', 'LU', 'AT', 'CH', 'LI', 'DK', 'SE', 'NO', 'FI', 'IS',
      // 南欧
      'ES', 'PT', 'IT', 'GR', 'MT', 'CY', 'AL', 'AD', 'BA', 'HR', 'ME', 'MK', 'RS', 'SI', 'SM', 'VA', 'XK',
      // 东欧
      'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'MD', 'UA', 'BY', 'RU', 'EE', 'LV', 'LT',
      // 领地及海外大区
      'FO', 'GI', 'AX', 'IM', 'MF', 'GF', 'PF', 'TF', 'IO', 'VG'
    ];

    const siteMapping = {
        'US': { name: 'United States', url: 'https://angelkissbag.us' },
        'CA': { name: 'Canada', url: 'https://angelkissbag.us' }
    };

    // 动态填充欧洲国家规则
    const ukUrl = 'https://angelkissbag.uk';
    europeCountries.forEach(code => {
        siteMapping[code] = {
            name: getCountryName(code),
            url: ukUrl
        };
    });

    try {
        // ==========================================
        // 4. 请求 GeoIP 接口
        // ==========================================
        const usresponse = await fetch(geoApiUrl, { cache: 'no-cache' });
        if (!usresponse.ok) return;

        const data = await usresponse.json();
        const userCountry = data.country;

        // ==========================================
        // 5. 判断国家与域名防重
        // ==========================================
        if (siteMapping[userCountry]) {
            const targetSite = siteMapping[userCountry];

            const targetHost = new URL(targetSite.url).hostname;
            if (window.location.hostname.includes(targetHost)) return;

            // 等待 DOM 加载完成后渲染弹窗
            ready(() => {
                // ==========================================
                // 6. 动态注入 CSS (含移动端响应式适配)
                // ==========================================
                const style = document.createElement('style');
                style.innerHTML = `
                    .geo-modal-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.6);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 999999;
                        padding: 15px;
                        box-sizing: border-box;
                    }
                    .geo-modal-box {
                        background: #fff;
                        padding: 30px 20px;
                        border-radius: 8px;
                        max-width: 420px;
                        width: 100%;
                        text-align: center;
                        position: relative;
                        box-shadow: 0 4px 15px rgba(0,0,0,0.15);
                    }
                    .geo-modal-close {
                        position: absolute;
                        top: 10px;
                        right: 15px;
                        font-size: 24px;
                        cursor: pointer;
                        color: #666;
                        line-height: 1;
                    }
                    .geo-modal-title {
                        font-size: 18px;
                        font-weight: bold;
                        margin-bottom: 12px;
                        color: #333;
                    }
                    .geo-modal-box p {
                        font-size: 14px;
                        color: #666;
                        line-height: 1.5;
                        margin-bottom: 20px;
                    }
                    .geo-modal-btn {
                        display: inline-block;
                        width: 100%;
                        padding: 12px 0;
                        background-color: #000;
                        color: #fff;
                        text-decoration: none;
                        border-radius: 4px;
                        font-size: 14px;
                        font-weight: bold;
                        box-sizing: border-box;
                    }
                `;
                document.head.appendChild(style);

                // ==========================================
                // 7. 动态创建 DOM
                // ==========================================
                const modalOverlay = document.createElement('div');
                modalOverlay.className = 'geo-modal-overlay';
                modalOverlay.innerHTML = `
                    <div class="geo-modal-box">
                        <span class="geo-modal-close" id="jsGeoClose">&times;</span>
                        <div class="geo-modal-title">You are visiting our Global Site</div>
                        <p>Would you like to switch to our <strong>${targetSite.name}</strong> store for a better shopping experience?</p>
                        <a href="${targetSite.url}" class="geo-modal-btn">Go to ${targetSite.name} Store</a>
                    </div>
                `;
                document.body.appendChild(modalOverlay);

                // ==========================================
                // 8. 事件绑定（同时支持 click 与 touchend）
                // ==========================================
                const closeBtn = document.getElementById('jsGeoClose');
                const handleClose = function (e) {
                    e.preventDefault();
                    modalOverlay.remove();
                    setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRE_DAYS);
                };

                closeBtn.addEventListener('click', handleClose);
            });
        }
    } catch (error) {
        console.error("GeoIP 引导逻辑异常:", error);
    }
})();


// =====================================根据浏览器语言限制========================================
// (function() {
//   var lang = (navigator.language || navigator.browserLanguage || '').toLowerCase();

//   var isIndia = lang.indexOf('-in') > -1;
 
//  //var isChina = lang.indexOf('zh-cn') > -1 
//   //           || lang.indexOf('zh-hk') > -1
//   //           || lang.indexOf('zh-mo') > -1
//    //          || lang.indexOf('zh-sg') > -1;
//      //        || isChina 
//   if (isIndia ) {
//     window.location.href = '/error';
//   }
// })();

// =======================================重定向=============================================================

  if (window.location.pathname === '/products/washed-vegan-leather-denim-style-crossbody-bag-womens-handbag') {
    window.location.replace('/products/washed-leather-multi-purpose-design-unique-design-crossbody-bag');
  }

  if (window.location.pathname === '/collections/hobo-bags-old') {
    window.location.replace('/collections/hobo-bags');
  }
  if (window.location.pathname === '/collections/tote-bags-old') {
    window.location.replace('/collections/tote-bags');
  }

  if (window.location.pathname === '/collections/backpack') {
    window.location.replace('/collections/backpacks');
  }
  if (window.location.pathname === '/collections/backpacks-old') {
    window.location.replace('/collections/backpacks');
  }

  if (window.location.pathname === '/collections/satchel-bags-old') {
    window.location.replace('/collections/satchel-bags');
  }

  if (window.location.pathname === '/collections/shoulder-bags-old') {
    window.location.replace('/collections/shoulder-bags');
  }


// ================================================================================国家ip拦截 开始================================================

(function() {
  // ===============================
  // Cookie 工具
  // ===============================
  // function getCookie(name) {
  //  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
   // return match ? match[2] : null;
 // } 
  function setBlockedCookie(type, mode) {
    const expire = new Date();
    if (mode === 'today') {
      expire.setHours(23, 59, 59, 999);
    } else {
      expire.setFullYear(expire.getFullYear() + 10);
    }
    document.cookie = `blocked=true; path=/; expires=${expire.toUTCString()}`;
    document.cookie = `blocked_reason=${type}; path=/; expires=${expire.toUTCString()}`;
  }
  // ===============================
  // 清屏
  // ===============================
  function clearPage() {
    document.documentElement.innerHTML = "";
    document.body.innerHTML = "";
    document.documentElement.style.visibility = "hidden";
  }

  // ===============================
  // GeoIP
  // ===============================
  async function getGeoIP() {
    try {
      const response = await fetch('https://akapi.angelkiss.cn/geoip/json/');
      const data = await response.json();
      return data.country;
    } catch (error) {
      return null;
    }
  }

  // ===============================
  // 获取 IP
  // ===============================
  async function getUserIP() {
    try {
      const response = await fetch('https://akapi.angelkiss.cn/gwip/get-ip');
      const ipData = await response.json();
      return ipData.ip;
    } catch (error) {
      return 'unknown';
    }
  }

// ================= 实时检测函数 =================

async function realtimeCheck() {
  // if (getCookie('blocked') === 'true') return; // 避免重复清屏 

  const country = await getGeoIP();
  const userIP = await getUserIP();
  // const blacklistedEmail = ['664825791@qq.com','664825791@qq.com'];
  //console.log('🌍 当前国家:', country, '📡 IP:', userIP); 
  const allowedIPs = ['58.63.1.36','113.103.1.33','122.192.18.224','35.85.251.99','183.12.67.90','150.40.205.97'];
  const blacklistedIPs = ['47.189.252.207', '70.170.228.30'];
  const blockedCountries = ['CN', 'TW','HK', 'MO', 'TR'];
  if (blacklistedIPs.includes(userIP)) {
    setBlockedCookie('ip', 'permanent');
    clearPage();
    return;
  }
  if (blockedCountries.includes(country) && !allowedIPs.includes(userIP)) {
    setBlockedCookie('country', 'permanent');
    clearPage();
    return;
  }
}

  // ===============================
  // 主逻辑
  // ===============================
  async function checkAccess() {
    try {
      // 已被封禁

      // if (getCookie('blocked') === 'true') {
      //  clearPage();
      //  return;
      // } 

      const country = await getGeoIP();
      const userIP = await getUserIP();

      // -------------------------------
      // IP / 国家规则（永久）
      // -------------------------------
      const allowedIPs = ['58.63.1.36','113.103.1.33','122.192.18.224','35.85.251.99','183.12.67.90','150.40.205.97'];
      const blacklistedIPs = ['47.189.252.207', '70.170.228.30'];
      const blockedCountries = ['CN','HK', 'TW', 'MO', 'TR'];

      if (blacklistedIPs.includes(userIP)) {
        setBlockedCookie('ip', 'permanent');
        clearPage();
        return;
      }

      if (blockedCountries.includes(country) && !allowedIPs.includes(userIP)) {
        setBlockedCookie('country', 'permanent');
        clearPage();
        return;
      }

      // -------------------------------
      // 行为风控：点击次数（按天）
      // -------------------------------
      const DOMAIN = location.hostname;
      const STORAGE_KEY = `activity_${DOMAIN}_${userIP}`;
      const TODAY = new Date().toDateString();
      const CLICK_LIMIT = 500;

      let data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {
        date: TODAY,
        clickCount: 0
      };

      // 跨天重置
      if (data.date !== TODAY) {
        data.date = TODAY;
        data.clickCount = 0;
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));

      function checkBehavior() {
        if (data.clickCount >= CLICK_LIMIT) {
          setBlockedCookie('behavior', 'today');
          clearPage();
        }
      }

      // 监听点击
      document.addEventListener('click', () => {
        data.clickCount++;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        checkBehavior();
      });

      // 页面加载时先检查一次
      checkBehavior();

      // 放行
      document.documentElement.style.visibility = 'visible';

    } catch (error) {
      console.error(error);
      document.documentElement.style.visibility = 'visible';
    }
  }


 checkAccess();

let lastIP = null;
let sameIPCount = 0;
let stage = 0; // 0: 15秒, 1: 3分钟, 2: 8分钟

let interval = 15000; // 初始间隔 15秒
let stageIntervalId = null;

async function ipCheck() {
  const currentIP = await getUserIP();

  if (currentIP === lastIP) {
    sameIPCount++;
  } else {
    sameIPCount = 1;
    lastIP = currentIP;
  }

  // 执行风控检测
  realtimeCheck();

  // 检查连续三次 IP 是否相同
  if (sameIPCount >= 2) {
    sameIPCount = 0; // 重置计数

    if (stage === 0) {
      // 15秒 → 3分钟
      stage = 1;
      interval = 180000; // 3分钟
      resetInterval();
    } else if (stage === 1) {
      // 3分钟 → 8分钟
      stage = 2;
      interval = 480000; // 8分钟
      resetInterval();
    } else if (stage === 2) {
      // IP稳定，停止检测
      clearInterval(stageIntervalId);
      //console.log("IP稳定，停止定时检测");
    }
  }
}

// 清理原来的定时器并重新启动新的间隔
function resetInterval() {
  clearInterval(stageIntervalId);
  stageIntervalId = setInterval(ipCheck, interval);
}

// 启动第一次检测
stageIntervalId = setInterval(ipCheck, interval);

    

// 人机验证




})();




// ================================================================================国家ip拦截 结束================================================


// /* ==========================
//    1. 禁用常见快捷键
// ========================== */
// document.addEventListener('keydown', function (e) {
//     const key = e.key ? e.key.toUpperCase() : '';
//     const keyCode = e.keyCode || e.which;

//     // F12
//     if (key === 'F12' || keyCode === 123) {
//         e.preventDefault();
//         return false;
//     }

//     // Ctrl + Shift + I / J / C
//     if (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(key)) {
//         e.preventDefault();
//         return false;
//     }

//     // Ctrl + U (查看源码)
//     if (e.ctrlKey && key === 'U') {
//         e.preventDefault();
//         return false;
//     }
// });

// /* ==========================
//    2. 禁用右键菜单 & 长按选择
// ========================== */
// document.addEventListener('contextmenu', function (e) {
//     e.preventDefault();
//     return false;
// });

// /* ==========================
//    3. 多维 DevTools 检测 (整合 PC 与移动模拟器)
// ========================== */
// (function antiDevTools() {
//     function refreshOrRedirect() {
//         // 触发检测后的动作
//         window.location.reload();
//         // 或跳转：window.location.href = '/';
//     }

//     // 方案 A: 窗口内外宽高差检测（针对 PC 侧边/底部 Dock 模式）
//     function checkWindowDiff() {
//         const threshold = 160;
//         const widthDiff = window.outerWidth - window.innerWidth > threshold;
//         const heightDiff = window.outerHeight - window.innerHeight > threshold;
//         return widthDiff || heightDiff;
//     }

//     // 方案 B: 利用 console.log 打印带有自定义 id 的对象 (专治独立窗口 DevTools)
//     let devtoolsOpenByConsole = false;
//     const element = new Image();
//     Object.defineProperty(element, 'id', {
//         get: function () {
//             devtoolsOpenByConsole = true;
//             refreshOrRedirect();
//             return '';
//         }
//     });

//     // 方案 C: 针对 Chrome 手机设备模拟模式 (Device Mode) 的精准检测
//     function checkDeviceEmulation() {
//         // 在 PC 端开模拟器时，某些浏览器下 outerWidth/Height 会被强制置 0
//         return window.outerWidth === 0 && window.outerHeight === 0;
//     }

//     // 方案 D: 动态 debugger 拦截与耗时检测
//     function checkDebugger() {
//         const startTime = performance.now();
//         (function () { }).constructor('debugger')();
//         const endTime = performance.now();
        
//         // 阈值设为 100ms，避免低性能手机误判
//         if (endTime - startTime > 100) {
//             refreshOrRedirect();
//         }
//     }

//     // 使用 Web Worker 独立线程驱动轮询，防止主线程被 debugger 暂停后导致 1 秒定时器卡死
//     try {
//         const workerBlob = new Blob([`
//             setInterval(function() {
//                 postMessage('tick');
//             }, 1000);
//         `], { type: 'application/javascript' });
        
//         const worker = new Worker(URL.createObjectURL(workerBlob));
//         worker.onmessage = function () {
//             runDetection();
//         };
//     } catch (e) {
//         // 备用方案：环境不支持 Worker 时退回主线程定时器
//         setInterval(runDetection, 1000);
//     }

//     function runDetection() {
//         // 1. 触发 Console 检查
//         devtoolsOpenByConsole = false;
//         console.log('%c', element);
//         console.clear();

//         // 2. 综合判断尺寸与 Console 探针
//         if (checkWindowDiff() || checkDeviceEmulation() || devtoolsOpenByConsole) {
//             refreshOrRedirect();
//         }

//         // 3. 执行 debugger 耗时检查
//         checkDebugger();
//     }
// })(); 